import { ETextStyleVariant, GeneralFlameIcon, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getViewsInLast30Days } from '@/redux/selectors/listing/page';
import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

export const BillSectionPopularChoice: React.FC = () => {
  const viewsInLast30Days = useSelector(getViewsInLast30Days);
  const isPopularChoiceWidgetV2Enabled = useExperimentIsEnabled(
    OptimizelyFlags.POPULAR_CHOICE_WIDGET_ON_LISTING_BILL_V2,
  );

  if (viewsInLast30Days < 100) return null;

  return (
    <div
      className={cn('flex items-center mt-2 gap-2 ', {
        'bg-gray-10 rounded-[4px] px-2 py-1': isPopularChoiceWidgetV2Enabled,
      })}>
      <GeneralFlameIcon
        className={isPopularChoiceWidgetV2Enabled ? 'text-bark-30' : 'text-red-300'}
      />
      <Text variant={ETextStyleVariant.SmallRegular}>
        <FormattedMessage
          defaultMessage="<Highlight>Popular choice!</Highlight> Viewed {viewCount} times this month"
          description="Listing page > Bill section > Popular choice widget indicating high view count"
          id="+EThxW"
          values={{
            viewCount: viewsInLast30Days,
            Highlight: text => (
              <span className={cn(isPopularChoiceWidgetV2Enabled && 'font-medium text-bark-30')}>
                {text}
              </span>
            ),
          }}
        />
      </Text>
    </div>
  );
};
